import { render, staticRenderFns } from "./StudentScheduleTable.vue?vue&type=template&id=58707286"
import script from "./StudentScheduleTable.vue?vue&type=script&lang=js"
export * from "./StudentScheduleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports